<template>
    <div class="content-wrapper  " style="background-color:#eee ; ">
        <preLoader v-if="loader"></preLoader>
        <div class="container">
            <div class="form-group" style="margin-top: 30px">
                <!--<router-link :to="{name: 'create-companyPayment'}" class="btn btn-success">افزودن</router-link>-->

                <span id="mintime" style="display:none">{{ new Date() | moment("jYYYY/jMM/jDD") }}</span>
  </div>



            <div class="row">

                <div class="col-md-6">

                <div class="col-md-6">
                    <div class="dbox dbox--color-1">
                        <div class="dbox__icon">
                            <i class="glyphicon glyphicon-download"></i>
                        </div>
                        <div class="dbox__body">
                            <span class="dbox__count">{{totalSum(orderItems)}}</span>
                            <span class="dbox__title">{{ $t('Number of visits') }} </span>
                        </div>

                        <div class="dbox__action">
                            <router-link class="dbox__action__btn" :to="`/report1`"> {{ $t('More information') }}
                            </router-link>

                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="dbox dbox--color-2">
                        <div class="dbox__icon">
                            <i class="glyphicon  glyphicon-list-alt "></i>
                        </div>
                        <div class="dbox__body">
                            <span class="dbox__count">{{ spliceNumber(totalSum(items))}} {{$curency}}</span>
                            <span class="dbox__title">{{ $t('Booking services') }} </span>
                        </div>

                        <div class="dbox__action">
                            <router-link class="dbox__action__btn" :to="`/services`"> {{ $t('Service managements') }}
                            </router-link>

                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="dbox dbox--color-3">
                        <div class="dbox__icon">
                            <i class="glyphicon glyphicon-gift"></i>
                        </div>
                        <div class="dbox__body">
                            <span class="dbox__count">{{ spliceNumber(totalSum(productItems))}} {{$curency}}</span>
                            <span class="dbox__title"> {{ $t('Sell Products') }}</span>
                        </div>

                        <div class="dbox__action">
                            <router-link class="dbox__action__btn" :to="`/managerProduct`">
                                {{ $t('Product Managements') }} </router-link>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                        <div class="dbox dbox--color-1">
                            <div class="dbox__icon">
                                <i class="glyphicon glyphicon-download"></i>
                            </div>
                            <div class="dbox__body">
                                <span class="dbox__count">{{totalSum(orderItems)}}</span>
                                <span class="dbox__title">{{ $t('Number of visits') }} </span>
                            </div>

                            <div class="dbox__action">
                                <router-link class="dbox__action__btn" :to="`/report1`"> {{ $t('More information') }}
                                </router-link>

                            </div>
                        </div>
                    </div>


                </div>

                <div class="col-md-6" style="margin-top: 50px">


                    <button type="button" class="btn btn-default" style="float: left; margin: 5px"
                            v-on:click="tableToExcel('testTable', 'W3C Example Table')" >{{ $t('Excel Output Report') }}</button>

                    <div class="panel panel-default ">
                        <div class="panel-heading">{{ $t('Cost and Income report') }}</div>

                        <div class="row p-4" dir="rtl">
                            <div class="col-xs-3">
                                <div class="form-group">
                                    <button class="btn btn-success top-20" @click="updateReport" >{{ $t('Update') }}</button>
                                </div>
                            </div>

                            <div class="col-xs-3">
                                <div class="form-group">
                                    <label for="">To</label>
                                    <custom-time-picker v-model="time.end" :clearable="true"
                                                        placeholder="تا تاریخ"
                                                        format="jYYYY/jMM/jDD" min="" max="" >
                                    </custom-time-picker>
                                </div>
                            </div>
                            <div class="col-xs-3">
                                <div class="form-group">
                                    <label for="">From</label>
                                    <custom-time-picker v-model="time.start" :clearable="true"
                                                        placeholder="از تاریخ"
                                                        format="jYYYY/jMM/jDD" min="" max="" >
                                    </custom-time-picker>
                                </div>
                            </div>

                            <!--<div class="col-xs-3">-->
                            <!--<div class="form-group">-->
                            <!--<label for=""></label>-->
                            <!--<input type="email" class="form-control" placeholder="کد "  v-model="search.number" aria-describedby="emailHelpId">-->
                            <!--</div>-->
                            <!--</div>-->

                        </div>


                        <div class="panel-body  ">
                            <div class="table-responsive">



                                <table  id="testTable" class="table table-bordered table-striped table-hover">

                                    <thead>
                                    <tr>
                                        <th colspan="6" style="background-color: #ff8f00; color: #fff">{{ $t('cost and income Total report') }} </th>
                                    </tr>
                                    <tr style="color: rgba(104,113,118,0.8)">
                                        <th  colspan="2">{{ $t('Number of visits') }}</th>
                                        <th colspan="4">{{totalSum(orderItems)}} </th>

                                    </tr>
                                    <tr style="color: #8e24aa">
                                        <th  colspan="2">{{ $t('Total revenue from booking services') }} </th>
                                        <th colspan="4">{{ spliceNumber(totalSum(items))}} {{$curency}}</th>

                                    </tr>

                                    <tr style="color: #0097a7">
                                        <th colspan="2">{{ $t('Total proceeds from product sales') }}  </th>
                                        <th colspan="4">{{ spliceNumber(totalSum(productItems))}} {{$curency}}</th>

                                    </tr>

                                    <tr style="color: #1565c0">
                                        <th colspan="2"> {{ $t('Total income') }}</th>
                                        <th colspan="4">{{ spliceNumber(totalSum(items)+totalSum(productItems))}} {{$curency}}</th>

                                    </tr>

                                    <tr style="color: #ad1457">
                                        <th colspan="2">{{ $t('Total cost') }} </th>
                                        <th colspan="4">{{ spliceNumber(totalSum(costItems))}} {{$curency}}</th>

                                    </tr>

                                    <tr>
                                        <th colspan="2">{{ $t('profit') }} </th>
                                        <th colspan="5">{{ spliceNumber(totalSum(items)+totalSum(productItems)-totalSum(costItems))}} {{$curency}}</th>

                                    </tr>

                                    </thead>






                                </table>


                                <!-- Trigger the modal with a button -->

                                <!-- Modal -->

                            </div>
                        </div>
                    </div>

                </div>
            </div>







            <div class="panel panel-default ">
                <div class="panel-heading">{{ $t('Total Income from reserving services') }}</div>



                <div class="panel-body  ">
                    <div class="table-responsive">



                        <table  id="testTable" class="table table-bordered table-striped table-hover">




                            <thead>
                            <tr >
                                <th colspan="6" style="background-color: #a01c7d; color: #fff">{{ $t('Total Income from reserving services') }}: </th>
                            </tr>
                            <tr>
                                <th>{{ $t('QTY') }}  </th>
                                <th>{{ $t('Title') }} </th>
                                <th> {{ $t('Amount') }}  ({{$curency}})</th>
                                <th colspan="3" > {{ $t('Number of use') }}</th>

                                <!--<th>تاریخ </th>-->


                                <!--<th>وضعیت </th>-->

                            </tr>
                            </thead>
                            <tbody>
                            <tr id="items" v-for="(item, index) in items" :key="index">
                                <td>{{ index+1 }}</td>
                                <td>{{ item.service.title }}</td>
                                <td>{{ spliceNumber(item.total) }}</td>
                                <td  colspan="3" >{{ item.servicesNumber }}</td>

                                <!--<td></td>-->
                                <!--<td>{{ item.due_date | moment("dddd, jD   ")}}</td>-->
                                <!--<td  v-text="filteritemType(item.type)">{{ item.type  }}</td>-->
                                <!--<td v-text="filteritem(item.state)">{{ item.state  }}</td>-->


                            </tr>

                            <tr >
                                <th colspan="2" style="background-color: #a01c7d; color: #fff">{{ $t('Total Income from reserving services') }}:


                                </th>

                                <th colspan="4" style="background-color: #a01c7d; color: #fff">
                                    <b >
                                        {{spliceNumber(totalSum(items)) }}
                                        {{$curency}}</b>

                                </th>


                            </tr>

                            </tbody>



                        </table>


                        <!-- Trigger the modal with a button -->

                        <!-- Modal -->

                    </div>
                </div>
            </div>





            <div class="panel panel-default ">
                <div class="panel-heading">{{ $t('Income from products') }}</div>

                <div class="panel-body  ">
                    <div class="table-responsive">



                        <table  id="testTable" class="table table-bordered table-striped table-hover">




                            <thead>
                            <tr >
                                <th colspan="6" style="background-color: #00c151; color: #fff">{{ $t('Income from products') }}: </th>
                            </tr>
                            <tr>
                                <th>{{ $t('QTY') }} </th>
                                <th>{{ $t('Title') }}</th>
                                <th> {{ $t('Amount') }} ({{$curency}})</th>
                                <th colspan="3" >{{ $t('Number of sale') }}</th>

                                <!--<th>تاریخ </th>-->


                                <!--<th>وضعیت </th>-->

                            </tr>
                            </thead>
                            <tbody>
                            <tr id="productItems" v-for="(productItem, productIndex) in productItems" :key="productIndex">
                                <td>{{ productIndex+1 }}</td>
                                <td>{{ productItem.product.title }}</td>
                                <td>{{ spliceNumber(productItem.total) }}</td>
                                <td  colspan="3" >{{  productItem.productNumber}}</td>

                                <!--<td></td>-->
                                <!--<td>{{ item.due_date | moment("dddd, jD   ")}}</td>-->
                                <!--<td  v-text="filteritemType(item.type)">{{ item.type  }}</td>-->
                                <!--<td v-text="filteritem(item.state)">{{ item.state  }}</td>-->


                            </tr>

                            <tr >
                                <th colspan="2" style="background-color: #00c151; color: #fff">{{ $t('Total Income from selling products') }}:


                                </th>

                                <th colspan="4" style="background-color: #00c151; color: #fff">
                                    <b>
                                        {{spliceNumber(totalSum(productItems)) }}
                                        {{$curency}}</b>

                                </th>


                            </tr>

                            </tbody>







                        </table>


                        <!-- Trigger the modal with a button -->

                        <!-- Modal -->

                    </div>
                </div>
            </div>




            <div class="panel panel-default ">
                <div class="panel-heading">{{ $t('cots') }}</div>



                <div class="panel-body  ">
                    <div class="table-responsive">



                        <table  id="testTable" class="table table-bordered table-striped table-hover">




                            <thead>
                            <tr>
                                <th colspan="6" style="background-color: #5c2278; color: #fff">{{ $t('cots') }}: </th>
                            </tr>
                            <tr>
                                <th>{{ $t('QTY') }}  </th>
                                <th>{{ $t('Title') }}</th>
                                <th> {{ $t('Amount') }}  ({{$curency}})</th>
                                <th colspan="3" > {{ $t('Description') }}</th>

                                <!--<th>تاریخ </th>-->


                                <!--<th>وضعیت </th>-->

                            </tr>
                            </thead>
                            <tbody>
                            <tr id="costItems" v-for="(costItem, costIndex) in costItems" :key="costIndex">
                                <td>{{ costIndex+1 }}</td>
                                <td v-text="filteritemType(costItem.type)">{{ costItem.type }}</td>
                                <td>{{ spliceNumber(costItem.total) }}</td>
                                <td  colspan="3" >{{  }}</td>

                                <!--<td></td>-->
                                <!--<td>{{ item.due_date | moment("dddd, jD   ")}}</td>-->
                                <!--<td  v-text="filteritemType(item.type)">{{ item.type  }}</td>-->
                                <!--<td v-text="filteritem(item.state)">{{ item.state  }}</td>-->


                            </tr>

                            <tr >
                                <th colspan="2" style="background-color: #5c2278; color: #fff">{{ $t('Total costs') }}:


                                </th>

                                <th colspan="4" style="background-color: #5c2278; color: #fff">
                                    <b >
                                        {{spliceNumber(totalSum(costItems)) }}
                                        {{$curency}}</b>

                                </th>


                            </tr>

                            </tbody>










                        </table>


                        <!-- Trigger the modal with a button -->

                        <!-- Modal -->

                    </div>
                </div>
            </div>




            <div class="panel panel-default ">
                <div class="panel-heading">{{ $t('pays') }}</div>


                <div class="panel-body  ">
                    <div class="table-responsive">



                        <table  id="testTable" class="table table-bordered table-striped table-hover">






                            <thead>
                            <tr>
                                <th colspan="6" style="background-color: #26a69a; color: #fff">{{ $t('pays') }}</th>
                            </tr>
                            <tr>
                                <th>{{ $t('QTY') }}  </th>
                                <th>{{ $t('Title') }}</th>
                                <th> {{ $t('Amount') }}  ({{$curency}})</th>
                                <th colspan="3" > {{ $t('Description') }}</th>

                                <!--<th>تاریخ </th>-->


                                <!--<th>وضعیت </th>-->

                            </tr>
                            </thead>
                            <tbody>
                            <tr id="paymentItems" v-for="(paymentItem, paymentIndex) in paymentItems" :key="paymentIndex">
                                <td>{{ paymentIndex+1 }}</td>
                                <td >{{ paymentItem.title }}</td>
                                <td>{{ spliceNumber(paymentItem.total) }}</td>
                                <td colspan="3" >{{  }}</td>

                                <!--<td></td>-->
                                <!--<td>{{ item.due_date | moment("dddd, jD   ")}}</td>-->
                                <!--<td  v-text="filteritemType(item.type)">{{ item.type  }}</td>-->
                                <!--<td v-text="filteritem(item.state)">{{ item.state  }}</td>-->


                            </tr>

                            <tr >
                                <th colspan="2" style="background-color: #26a69a; color: #fff">{{ $t('Sum of payments') }}:


                                </th>

                                <th colspan="4" style="background-color: #26a69a; color: #fff">
                                    <b >
                                        {{spliceNumber(totalSum(paymentItems)) }}
                                        {{$curency}}</b>

                                </th>


                            </tr>

                            </tbody>









                        </table>


                        <!-- Trigger the modal with a button -->

                        <!-- Modal -->

                    </div>
                </div>
            </div>




            <div class="panel panel-default ">
                <div class="panel-heading">{{ $t('Personnel Income') }}</div>

                <div class="panel-body  ">
                    <div class="table-responsive">



                        <table  id="testTable" class="table table-bordered table-striped table-hover">







                            <thead>
                            <tr>
                                <th colspan="6" style="background-color: #e1cce1; color: #222">{{ $t('Personnel Income') }}: </th>
                            </tr>
                            <tr>
                                <th>{{ $t('QTY') }} </th>
                                <th>{{ $t('Personnel') }}</th>
                                <th> {{ $t('The whole function') }} ({{$curency}})</th>
                                <th> {{ $t('Number of serve') }} </th>
                                <th> {{ $t('Average of serve') }} ({{$curency}})</th>
                                <th>{{ $t('Personnel Income') }}  ({{$curency}})</th>

                                <!--<th>تاریخ </th>-->


                                <!--<th>وضعیت </th>-->

                            </tr>
                            </thead>
                            <tbody>
                            <tr id="personItems" v-for="(personItem, personIndex) in personItems" :key="personIndex">
                                <td>{{ personIndex+1 }}</td>
                                <td >
                                    <span v-if="personItem.person">
                                       {{ personItem.person.name }}  {{ personItem.person.family }}

                                    </span>
                                    <span v-else>
                                    {{ $t('Unknown') }}
                                    </span>

                                </td>


                                <td>
                                    {{ spliceNumber(personItem.total) }}
                                </td>

                                <td>
                                    {{ personItem.serveNumber }}
                                </td>

                                <td>
                                    {{ spliceNumber(Math.round(personItem.total/personItem.serveNumber)) }}
                                </td>


                                <td style="font-weight: bold">
                                     <span v-if="personItem.person && personItem.person.min_time != null && personItem.person.min_time != ''">
                                    {{ spliceNumber((personItem.total)*(personItem.person.min_time/100)) }}
                                    </span>
                                    <span v-else>
                                    {{ spliceNumber(personItem.total) }}
                                    </span>
                                </td>


                                <!--<td></td>-->
                                <!--<td>{{ item.due_date | moment("dddd, jD   ")}}</td>-->
                                <!--<td  v-text="filteritemType(item.type)">{{ item.type  }}</td>-->
                                <!--<td v-text="filteritem(item.state)">{{ item.state  }}</td>-->


                            </tr>

                            <tr>
                                <th colspan="2" style="background-color: #e1cce1; color: #222">{{ $t('Sum of functions') }}:


                                </th>

                                <th colspan="4" style="background-color: #e1cce1; color: #222">
                                    <b >
                                        {{spliceNumber(totalSum(personItems)) }}
                                        {{$curency}}</b>

                                </th>


                            </tr>

                            </tbody>





                        </table>


                        <!-- Trigger the modal with a button -->

                        <!-- Modal -->

                    </div>
                </div>
            </div>



































            <div class="col-xs-12 text-center">

                <!--<pagination api="api/payment/CompanyPayment" @pagnationChangeDate='pagnation'></pagination>-->
            </div>
        </div>
    </div>
</template>


<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };

    export default {

        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                items: [],
                productItems: [],
                costItems: [],
                orderItems: [],
                paymentItems: [],
                personItems: [],
                loader:false,

                search:{},
                time: {
                    end: '1399/12/12',
                    start: '1398/12/01'
                },

            }
        },


        mounted() {
            this.loader=true
            this.time.start = document.getElementById("mintime").innerHTML
            this.time.end = document.getElementById("mintime").innerHTML

            this.serviceReport()
            this.productReport()
            this.costReport()
            this.orderReport()
            this.paymentReport()
            this.personReport()


//                .finally(() => this.loading = false)
        }


        ,
        methods: {
//   pagnation(api) {
//                // console.log(api,"m")
//                axios.get(api, this.auth)
//                    .then(response => {
//                        // this.current_page = response.data.current_page
//                        this.items = response.data.data;
//                        //  console.log(response.data.data)
//                        // this.pagnationDate = response.data
//                        //  console.log(this.pagnationDate)
//                    })
//                    .catch(error => {
//                        console.log(error);
//                        this.errored = true
//                    })
//                    .finally(() => this.loading = false)
//            },


            serviceReport(){
                axios
                    .get(
                        `/api/generalServiceReport?${"date_from="+ this.time.start +"&"+ "date_to="+ this.time.end}&price=total&filter=service&sort=desc`,
                        this.auth)
                    .then(response => {
                        this.items = response.data;
                        console.log(this.items);
                        this.loader=false
                    })
                    .catch(error => {
                        this.loader = false
                        if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                            this.$snotify.warning(this.$t('Your access to this section is restricted'));
                        } else {
                            this.$snotify.warning(error.response.data.message);
                        }

                        console.log(error);
                        this.loading = false
                        this.errored = true
                    })

            },

            productReport(){
                axios
                    .get(
                        `/api/generalProductReport?${"date_from="+ this.time.start +"&"+ "date_to="+ this.time.end}&price=total&filter=product&sort=desc`,
                        this.auth)
                    .then(response => {
                        this.productItems = response.data;
                        console.log(this.productItems);
                        this.loader=false
                    })
                    .catch(error => {
                        this.loader = false
                        if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                            this.$snotify.warning(this.$t('Your access to this section is restricted'));
                        } else {
                            this.$snotify.warning(error.response.data.message);
                        }

                        console.log(error);
                        this.loading = false
                        this.errored = true
                    })

            },


            costReport(){
                axios
                    .get(
                        `/api/generalCostReport?${"date_from="+ this.time.start +"&"+ "date_to="+ this.time.end}`,
                        this.auth)
                    .then(response => {
                        this.costItems = response.data;
                        console.log(this.costItems);
                        this.loader=false
                    })
                    .catch(error => {
                        this.loader = false
                        if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                            this.$snotify.warning(this.$t('Your access to this section is restricted'));
                        } else {
                            this.$snotify.warning(error.response.data.message);
                        }

                        console.log(error);
                        this.loading = false
                        this.errored = true
                    })

            },



            orderReport(){
                axios
                    .get(
                        `/api/generalOrderReport?${"date_from="+ this.time.start +"&"+ "date_to="+ this.time.end}`,
                        this.auth)
                    .then(response => {
                        this.orderItems = response.data;
                        console.log(this.orderItems);
                        this.loader=false
                    })
                    .catch(error => {
                        this.loader = false
                        if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                            this.$snotify.warning(this.$t('Your access to this section is restricted'));
                        } else {
                            this.$snotify.warning(error.response.data.message);
                        }

                        console.log(error);
                        this.loading = false
                        this.errored = true
                    })

            },



            paymentReport(){
                axios
                    .get(
                        `/api/generalPaymentReport?${"date_from="+ this.time.start +"&"+ "date_to="+ this.time.end}`,
                        this.auth)
                    .then(response => {
                        this.paymentItems = response.data;
                        console.log(this.paymentItems);
                        this.loader=false
                    })
                    .catch(error => {
                        this.loader = false
                        if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                            this.$snotify.warning(this.$t('Your access to this section is restricted'));
                        } else {
                            this.$snotify.warning(error.response.data.message);
                        }

                        console.log(error);
                        this.loading = false
                        this.errored = true
                    })

            },



            personReport(){
                axios
                    .get(
                        `/api/generalPersonReport?${"date_from="+ this.time.start +"&"+ "date_to="+ this.time.end}`,
                        this.auth)
                    .then(response => {
                        this.personItems = response.data;
                        console.log(this.personItems);
                        this.loader=false
                    })
                    .catch(error => {
                        this.loader = false
                        if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                            this.$snotify.warning(this.$t('Your access to this section is restricted'));
                        } else {
                            this.$snotify.warning(error.response.data.message);
                        }

                        console.log(error);
                        this.loading = false
                        this.errored = true
                    })

            },








            updateReport(){
                this.serviceReport()
                this.productReport()
                this.costReport()
                this.orderReport()
                this.personReport()

            },




            totalSum(items) {

                var total =  0;



//                for(var i=0;i<items.length;i++)
//                {
//                    if(isNaN(this.pluck(items, total))){
//                        continue;
//                    }
//                    total += Number(this.pluck(items, total));
//                }

                console.log(this.pluck(items, 'total'))

//                console.log(sum([1,2,3]))

                this.pluck(items, 'total').forEach(function(element){
                    console.log(element)

                    total = Number(total)+Number(element)


                })


                return total;

            },

            pluck(array, key) {
                return array.map(function (obj) {
                    return obj[key];
                });
            },

            filteritem(item) {

                if (item == 1) {
                    return  this.$t('Active')
                } else {
                    return  this.$t('Inactive')
                }
            },

            filteritemType(item) {

                switch (item) {
                    case 0:
                        return  this.$t('Other cots')
                        break;
                    case 1:
                        return  this.$t('Buying Equipment')
                        break;
                    case 2:
                        return   this.$t('Buying goods')
                        break;
                    case 3:
                        return  this.$t('Transportation cost')
                        break;
                    case 4:
                        return this.$t('Forwarding(transportation) cost ')
                        break;
                    case 5:
                        return   this.$t('Water, electricity, telephone bills')
                        break;
                    case 6:
                        return  this.$t('Salary cost ')
                        break;
                    case 7:
                        return  this.$t('Payable documents')
                        break;
                    case 8:
                        return  this.$t('Renting cost')
                        break;
                    case 9:
                        return   this.$t('Fund/?')
                        break;
                    case '0':
                        return  this.$t('Other cots')
                        break;
                    default:
                        return   this.$t('Other cots ')
                }

            },

            spliceNumber(number) {
                //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

                $("input[data-type='number']").keyup(function (event) {
                    var $this = $(this);
                    var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
                    $this.val(num2);
                });
                if(number != null){
                    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")

                }
            },





            tableToExcel (table, name) {

                var uri = 'data:application/vnd.ms-excel;base64,'
                    , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:ExcelSheetViews><x:ExcelSheetView rightToLeft=1></x:ExcelSheetView></x:ExcelSheetViews><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                    , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
                    , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }


                if (!table.nodeType) table = document.getElementById(table)
                var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
                window.location.href = uri + base64(format(template, ctx))

            }



        }
    }

</script>
<!--<script>-->
<!--export default {-->
<!--computed: {-->
<!--username() {-->
<!--// We will see what `params` is shortly-->
<!--return this.$route.params.username-->
<!--}-->
<!--},-->
<!--methods: {-->
<!--goBack() {-->
<!--window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')-->
<!--}-->
<!--}-->
<!--}-->
<!--</script>-->
